var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"no-margins"},[_c('ActionButton',{staticClass:"mt-4",attrs:{"actionIcon":"$sl-bankid"},on:{"click":function($event){return _vm.doExternalLogin()}}},[_vm._v(_vm._s(_vm.buttonText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }